<div class="h-screen w-full bg-gray-200 flex flex-col overflow-hidden" [class.gis-focus-mode]="isGisFocusMode">
  <app-header *ngIf="!isGisFocusMode"></app-header>
  <div class="flex relative w-full flex-1 min-h-0 overflow-hidden">
    <!-- App menu: fixed width so map/content never overlaps it; stays on top -->
    <div
      *ngIf="!isGisFocusMode"
      class="flex-shrink-0 flex flex-col h-full transition-[width] duration-300 ease-in-out z-[100]"
      [style.width.px]="isSidebarExpanded ? 268 : 72"
    >
      <app-side-menu-bar></app-side-menu-bar>
    </div>
    <!-- Main content: takes remaining width only, never under the menu -->
    <div
      class="flex-1 flex flex-col overflow-hidden bg-gray-50 min-h-0 min-w-0 w-full z-10"
    >
      <div
        class="flex-1 min-h-0 min-w-0"
        [ngClass]="isMapEditorRoute ? 'gis-map-outlet overflow-hidden flex flex-col p-0' : 'overflow-y-auto p-6'"
      >
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>

  <app-footer class="bg-primary" *ngIf="!isMapEditorRoute && !isGisFocusMode"></app-footer>
</div>
